import type { ReportRunArtifact, UnsettledReportRun } from "~reports/executions/helpers/reportRunResult";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ReportRunsState {
	artifact: null | ReportRunArtifact;
	unsettledByReportId: Record<string, UnsettledReportRun>;
}

const initialState: ReportRunsState = {
	artifact: null,
	unsettledByReportId: {}
};

export const reportRunsSlice = createSlice({
	initialState,
	name: "reportRuns",
	reducers: {
		holdUnsettledReportRun: (state, action: PayloadAction<UnsettledReportRun>) => {
			state.unsettledByReportId[action.payload.attempt.reportId] = action.payload;
		},
		keepReportRunArtifact: (state, action: PayloadAction<ReportRunArtifact>) => {
			state.artifact = action.payload;
		},
		settleReportRun: (state, action: PayloadAction<string>) => {
			delete state.unsettledByReportId[action.payload];
		}
	}
});

export const { holdUnsettledReportRun, keepReportRunArtifact, settleReportRun } = reportRunsSlice.actions;

export default reportRunsSlice.reducer;
